import React, {Fragment} from 'react'

const AddCustomer = (props) => {
    return (
        <Fragment>
            <div className="maximumSizeHandler">
                <div className="contentTitle ">
                    <div className="longTitle">
                        <span className="back"><span
                            className="icon icon-arrow-right font-size_14"></span> بازگشت </span>
                        <span className="separator"></span>
                        <span className=" font-size_24 boldFont middleContext">افزودن مشتری جدید</span>
                        <span className="icon icon-arrow-left middleContext verticalSpace"></span>
                        <span className="customerName font-size_14 mediumWFont">محمد پوراسکندر</span>
                        <span className="separator"></span>
                        <span className="costumerCreationDate font-size_14 lightFont">تاریخ ایجاد: ۹۸/۱۰/۱۲</span>
                    </div>
                </div>
            </div>
            <span className="lineSeparator"></span>
            <div className="sizeHandler_1185">
                <div className="addBookForm">
                    <div className="organizer addCustomer">
                        <div className="formContainer">
                            <div className="multipleOption organizer">
                                <div className="checkOption blockInline">
                                    <span className="checkBox"></span> <span className="icon icon-user"></span> مشتری
                                    حقیقی
                                </div>
                                <div className="checkOption blockInline">
                                    <span className="checkBox"></span> <span
                                    className="icon icon-building"></span> مشتری حقوقی
                                </div>
                            </div>
                            <div className="inputContainer title">
                                <label>نام و نام خانوادگی</label>
                                <input className="standardInput" />
                            </div>
                            <div className="inputContainer title">
                                <label>ایمیل</label>
                                <input className="standardInput" />
                            </div>
                            <div className="inputContainer publisher">
                                <label>شماره تلفن</label>
                                <input className="standardInput" />
                            </div>
                            <div className="inputContainer description">
                                <label>توضیحات</label>
                                <textarea className="standardInput"></textarea>
                            </div>

                            <div className="normalButton outlineMode greenButton"><span
                                className="icon icon-edit font-size_14 middleContext"></span> ویرایش مشتری
                            </div>
                            <div className="normalButton outlineMode greenButton"><span
                                className="icon icon-add font-size_14 middleContext"></span> اضافه کردن مشتری
                            </div>

                            <div className="normalButton outlineMode deleteButton"><span
                                className="icon icon-eraser font-size_14 middleContext"></span> حذف مشتری
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default AddCustomer;
